import asyncLoadImage from './utils/async-load-image';
import isBannerOpen from './utils/is-banner-open';
import closeButtonEvent from './utils/close-button-event';
import {
	endBannerElement,
	endBannerSelectors as selectors,
	hiddenClass,
	visibleClass,
} from './constants';

const isEndBannerOpen = isBannerOpen( endBannerElement );

const endBannerWidth = {
	dpi1x: '?width=1276',
	dpi2x: '?width=2552',
};

export default function campaignEndBanner ( campaignData ) {
	if ( ! endBannerElement ) {
		return;
	}

	if (
		( campaignData && isEndBannerOpen === 'firstVisit' ) ||
		isEndBannerOpen === true
	) {
		const {
			gaLabel,
			adDescription,
			imageSrc,
			hexCode,
			campaignLink,
			leftColumnHexCode,
			rightColumnHexCode,
		} = campaignData;

		endBannerElement.setAttribute( 'data-component-name', gaLabel );

		const elements = {
			image: endBannerElement.querySelector( selectors.image ),
			wrapper: endBannerElement.querySelector( selectors.wrapper ),
			link: endBannerElement.querySelector( selectors.link ),
			leftColumn: endBannerElement.querySelector( selectors.leftColumn ),
			rightColumn: endBannerElement.querySelector( selectors.rightColumn ),
		};

		if ( adDescription ) {
			elements.image.setAttribute( 'alt', adDescription );
		}

		asyncLoadImage( imageSrc, elements.image, endBannerWidth );

		if ( hexCode ) {
			elements.wrapper.setAttribute( 'style', `backgroundColor: ${hexCode}` );
		}

		if ( campaignLink ) {
			elements.link.setAttribute( 'href', campaignLink );
		}

		if ( leftColumnHexCode ) {
			elements.leftColumn.setAttribute( 'style', `backgroundColor" ${leftColumnHexCode}` );
		}

		if ( rightColumnHexCode ) {
			elements.rightColumn.setAttribute( 'style', `rightColumnHexCode" ${leftColumnHexCode}` );
		}

		endBannerElement.classList.add( visibleClass );
		closeButtonEvent( endBannerElement, false );
	} else {
		endBannerElement.classList.remove( visibleClass );
		endBannerElement.classList.add( hiddenClass );
	}
}
